export enum AmplitudeEvent {
  // ── Page & Session ──
  PAGE_VIEWED = 'Page Viewed',
  SESSION_STARTED = 'Session Started',
  // ── Onboarding Funnel ──
  QUIZ_STARTED = 'Quiz Started',
  QUESTION_VIEWED = 'Onboarding Question Viewed',
  QUESTION_ANSWERED = 'Onboarding Question Answered',
  QUIZ_COMPLETED = 'Quiz Completed',
  // ── Paywall & Purchase ──
  PAYWALL_VIEWED = 'Paywall Viewed',
  PLAN_SELECTED = 'Plan Selected',
  CHECKOUT_STARTED = 'Checkout Started',
  PURCHASE_COMPLETED = 'Purchase Completed',
  PURCHASE_FAILED = 'Purchase Failed',
  // ── Post-Purchase ──
  ACCOUNT_CREATED = 'Account Created',
  PLAN_ACTIVATED = 'Plan Activated',
  FIRST_WALK_STARTED = 'First Walk Started',
  WALK_COMPLETED = 'Walk Completed',
}
